<template>
    <div class="app-container">
        <el-form
            ref="addAddressform"
            label-width="100px"
            :inline="true"
            :model="addAddressform"
            :rules="addAddressRules"
        >
            <el-form-item label="联系人" prop="name">
                <el-input maxlength="30" v-model="addAddressform.name" style="width: 240px" />
            </el-form-item>
            <el-form-item label="手机" prop="phone">
                <el-input maxlength="20" v-model="addAddressform.phone" style="width: 240px" />
            </el-form-item>
            <el-form-item label="qq">
                <el-input maxlength="20" v-model="addAddressform.qq" style="width: 240px" />
            </el-form-item>
            <el-form-item label="微信">
                <el-input
                    v-model="addAddressform.wechat"
                    maxlength="20"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="货运" prop="transportId" v-if="$global.useinstall!=1">
                <el-select v-model="addAddressform.transportId" filterable value-key="id" style="width: 240px">
                    <el-option v-for="item in transList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="区域" prop="area">
                <el-cascader
                    ref="district"
                    v-model="addAddressform.area"
                    :options="options_"
                    placeholder="省市区"
                    style="width: 240px"
                />
            </el-form-item>
            <el-form-item label="详细地址" prop="address">
                <el-input
                    v-model="addAddressform.address"
                    maxlength="50"
                    style="width: 240px"
                />
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { regionData, CodeToText, TextToCode } from "element-china-area-data";
export default {
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            options_: regionData,
            addAddressform: {
                name: "",
                phone: "",
                qq: "",
                wechat: "",
                transportId: "",
                area: "",
                address: "",
            },
            addAddressRules: {
                name: [
                    {
                        required: true,
                        message: "请输入联系人",
                    },
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入联系电话",
                    },
                ],
                area: [
                    {
                        required: true,
                        message: "请选择区域",
                    },
                ],
                transportId: [
                    {
                        required: true,
                        message: "请输入货运",
                    },
                ],
                address: [
                    {
                        required: true,
                        message: "请输入详细地址",
                    },
                ],
            },
            transList:[],
        };
    },
    created(){
        this.$api.getInfoPostSingle('/mobile/customer/listTransport',{limit:-1}).then(res=>{
            if(res.data.code==1){
                res.data.data.forEach(e=>{
                    let obj = {
                        label:e.name+e.phone+e.district.join(''),
                        id:e.id,
                    }
                    this.transList.push(obj);
                })
            }
        }) 
    },
    methods: {
        getInfo() {
            this.$api.customercustomerAddress({ id: this.item.id }).then((res) => {
                    let data = res.data.data;
                    this.addAddressform = data;
					this.$set(this.addAddressform, "area", []);
					if (data.district.length > 0) {
                        this.addAddressform.area.push(
                            TextToCode[data.district[0]].code
                        );
					}
					if (data.district.length > 1) {
                        this.addAddressform.area.push(
                            TextToCode[data.district[0]][data.district[1]].code
                        );
                    }
                    if (data.district.length > 2) {
                        this.addAddressform.area.push(
                            TextToCode[data.district[0]][data.district[1]][data.district[2]].code
                        );
                    }
                    let temp = [];
                    for (let i = 0;i < this.addAddressform.district.length;i++) {
                        if (i == 3) {
                            break;
                        }
                        let dis = this.addAddressform.district[i];
                        temp.push(dis);
                    }
                    this.addAddressform.district = temp;
                });
        },
        saveEditClose(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
					if(!this.$common.checkPhone(this.addAddressform.phone)){
						this.$common.error("号码不正确");
						return;
                    }
                    
                    this.addAddressform.district = [];
                    this.addAddressform.district.push(
                        CodeToText[this.addAddressform.area[0]]
                    );
                    this.addAddressform.district.push(
                        CodeToText[this.addAddressform.area[1]]
                    );
                    this.addAddressform.district.push(
                        CodeToText[this.addAddressform.area[2]]
                    )
                    this.addAddressform.district = this.addAddressform.district.join(',');
                    this.addAddressform.area = this.addAddressform.area.join(',');
                    this.$api
                        .customereditCustomerAddress(this.addAddressform)
                        .then((res) => {
                            this.$emit("close");
                            this.$notify({
                                title: "修改收货地址",
                                message: "修改成功",
                                type: "success",
                                duration: 2000,
                            });
                        });
                } else {
                    this.$notify({
                        title: "信息填写不完善",
                        message: "请完善信息",
                        type: "warning",
                        duration: 2000,
                    });
                }
            });
        },
    },
};
</script>